export default __webpack_public_path__ + "static/media/transplantation-medicine.ddf4b448.jpg";